import { DataManager } from '@syncfusion/ej2-data';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AcodisWorkflowDTO, ImportType } from 'src/app/base/models/models.swagger.generated';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { AcodisWorkflowService } from '../acodis-workflow.service';
import { AvpCustomAdaptor } from 'src/app/base/shared/syncfusion/avp-custom-adaptor';
import { GridModule, RowSelectEventArgs } from '@syncfusion/ej2-angular-grids';
import { QueryBuilderModule } from '@syncfusion/ej2-angular-querybuilder';
import { AcodisWorkflowFormType } from '../acodis-workflow-form/acodis-workflow-form-type';
import { GridBaseComponent } from 'src/app/base/shared/grid-base/grid-base.component';

@Component({
    selector: 'app-acodis-workflow-overview',
    templateUrl: './acodis-workflow-overview.component.html',
    styleUrls: ['./acodis-workflow-overview.component.scss'],
    imports: [ GridModule, QueryBuilderModule, TranslateModule, ReactiveFormsModule ]
})
export class AcodisWorkflowOverviewComponent extends GridBaseComponent<any> implements OnInit {

  @Output()
  public recordSelected = new EventEmitter<AcodisWorkflowDTO>();

  @Output()
  public recordDoubleClick = new EventEmitter<AcodisWorkflowDTO>();

  @Output()
  public dataBoundEvent = new EventEmitter<void>();

  @Input()
  public acodisWorkflowForm: FormGroup<AcodisWorkflowFormType>;

  public ImportType = ImportType;

  constructor(
    translateService: TranslateService,
    protected workflowService: AcodisWorkflowService,
    private spinnerService: SpinnerService  ) {
    super(translateService, workflowService);
  }

  ngOnInit() {
    this.data = new DataManager({
      adaptor: new AvpCustomAdaptor(this.workflowService, this.spinnerService)
    });
  }

  public onRowSelected(args: RowSelectEventArgs): void {
    this.emitRecordSelected(args);
  }

  public dataBound() {
    this.dataBoundEvent.emit();
  }

  public refresh() {
    this.grid?.refresh();
  }

  public resetRowSelected() {
    if (this.grid?.selectedRowIndex >= 0) {
      this.grid?.selectRows([]);
    }
  }

  protected initializeEditForm(data: AcodisWorkflowDTO): void {
    throw new Error('Method not implemented.');
  }

  protected getEditDialogTitleParams(rowData: any): object {
    throw new Error('Method not implemented.');
  }


  private emitRecordSelected(args: RowSelectEventArgs) {
    const data = args.data as AcodisWorkflowDTO;
    if (data) {
      this.recordSelected.emit(data);
    }
  }
}
